var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntitlementB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25368 0.852539H7.44337C9.70859 0.852539 10.8426 0.852539 11.6292 1.40703C11.8543 1.56546 12.0544 1.75446 12.2233 1.96639C12.8125 2.7071 12.8125 3.77301 12.8125 5.9062V7.67461C12.8125 9.73345 12.8125 10.7632 12.4866 11.5852C11.9627 12.9075 10.8551 13.9498 9.45011 14.4432C8.57668 14.7496 7.48367 14.7496 5.29489 14.7496C4.04554 14.7496 3.42017 14.7496 2.92127 14.5745C2.11871 14.2924 1.4857 13.6969 1.18622 12.9416C1 12.4719 1 11.8833 1 10.7069V7.80107",
    stroke: "#5C678F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 7.80107C12.8125 8.4153 12.5685 9.00436 12.1341 9.43869C11.6998 9.87301 11.1108 10.117 10.4965 10.117C10.0338 10.117 9.4883 10.0364 9.03873 10.1566C8.84237 10.2094 8.66333 10.3129 8.51955 10.4567C8.37577 10.6005 8.2723 10.7795 8.21949 10.9759C8.09928 11.4254 8.17989 11.9709 8.17989 12.4337C8.17989 12.7378 8.11998 13.0389 8.0036 13.3199C7.88721 13.6009 7.71662 13.8562 7.50156 14.0713C7.28651 14.2863 7.0312 14.4569 6.75022 14.5733C6.46923 14.6897 6.16808 14.7496 5.86394 14.7496M1.69482 2.58967C2.03669 2.23808 2.94556 0.852539 3.43196 0.852539M3.43196 0.852539C3.91835 0.852539 4.82722 2.23808 5.16909 2.58967M3.43196 0.852539V6.41136",
    stroke: "#5C678F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitlementB);
export default __webpack_public_path__ + "static/media/EntitlementB.a83b86aa4a179fc7e2234a5b6d4de90e.svg";
export { ForwardRef as ReactComponent };